import React from "react";

interface QuestionIconProps {
  size?: number;
  color?: string;
  hoverColor?: string;
  onClick?: () => void;
}

const QuestionIcon: React.FC<QuestionIconProps> = ({
  size = 20,
  color = "#3D4242",
  hoverColor = "#21C4B8",
  onClick,
}) => {
  return (
    <span
      role="img"
      aria-label="help"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "help",
        lineHeight: 0,
      }}
      onClick={onClick}
    >
      <svg
        viewBox="0 0 1024 1024"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M512 64A448 448 0 1 0 960 512 448.5 448.5 0 0 0 512 64z m0 832a384 384 0 1 1 384-384 384.5 384.5 0 0 1-384 384z" />
        <path d="M512 736a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM512 224a160 160 0 0 0-160 160 32 32 0 0 0 64 0 96 96 0 1 1 137.4 86.6A129.4 129.4 0 0 0 480 586.4V640a32 32 0 1 0 64 0v-53.6a64.3 64.3 0 0 1 37.1-58.1A160 160 0 0 0 512 224z" />
        <style>{`path{transition:fill .2s ease; fill:${color}} svg:hover path{fill:${hoverColor}}`}</style>
      </svg>
    </span>
  );
};

export default QuestionIcon;
